import { useCallback } from 'react';
import {
  CrewNumberError,
  type CrewNumberCheck,
  type NextCrewNumber,
} from '@/lib/crewNumberAvailability';
import { useSupabase } from './useSupabase';

export function useCrewNumberAvailability() {
  const supabase = useSupabase();

  const peekNext = useCallback(
    async (productId: string): Promise<NextCrewNumber> => {
      const { data, error } = await supabase
        .rpc('peek_next_crew_number', { p_product_id: productId })
        .single();

      if (error) throw new CrewNumberError(error.message);
      if (!data) throw new Error('Aucun numéro disponible retourné.');
      return data as NextCrewNumber;
    },
    [supabase]
  );

  const check = useCallback(
    async (productId: string, crewNumberInt: number): Promise<CrewNumberCheck> => {
      const { data, error } = await supabase
        .rpc('check_crew_number_availability', {
          p_product_id: productId,
          p_crew_number_int: crewNumberInt,
        })
        .single();

      if (error) throw new CrewNumberError(error.message);
      if (!data) throw new Error('Aucun contrôle de numéro retourné.');
      return data as CrewNumberCheck;
    },
    [supabase]
  );

  return { peekNext, check };
}
